import { useEffect } from "react";
import { QRCodeSVG } from "qrcode.react";
import { Printer, Star } from "lucide-react";
import Logo from "@/components/Logo";
import Seo from "@/components/Seo";
import { SITE } from "@/data/site";

export default function ReviewPage() {
  useEffect(() => {
    const meta = document.createElement("meta");
    meta.name = "robots";
    meta.content = "noindex, nofollow";
    document.head.appendChild(meta);
    return () => meta.remove();
  }, []);

  return (
    <main className="review-page min-h-screen bg-brand-paper py-10 print:bg-white print:py-0" data-testid="review-page">
      <Seo title="Leave Fusion Glass a Google review" description="Scan the QR code to leave Fusion Glass a Google review." path="/review" />

      <div className="container-x mb-6 flex items-center justify-between gap-4 print:hidden">
        <p className="text-sm text-slate-600">
          Print this card (A5 or A4) and hand it over at job completion, or show it on your phone.
        </p>
        <button type="button" onClick={() => window.print()} className="btn-outline !px-5 !py-2.5 !text-xs" data-testid="review-print-btn">
          <Printer className="h-4 w-4 text-brand-red" /> Print card
        </button>
      </div>

      <section className="mx-auto flex w-full max-w-[640px] flex-col items-center rounded-[2rem] border border-slate-200 bg-white px-10 py-14 text-center shadow-[0_30px_80px_rgba(16,24,40,0.12)] print:max-w-none print:rounded-none print:border-0 print:shadow-none" data-testid="review-card">
        <Logo />

        <p className="mt-10 font-mono text-[10px] uppercase tracking-[0.4em] text-brand-red">Thank you for choosing us</p>
        <h1 className="mt-4 font-display text-3xl font-extrabold tracking-tight text-slate-900 sm:text-4xl">
          Happy with your <span className="text-brand-red">glass?</span>
        </h1>
        <p className="mt-4 max-w-md text-sm leading-relaxed text-slate-600 sm:text-base">
          We're a small family team - three installers and one admin - and every Google review helps the next
          customer find us. It takes 60 seconds, and we read every one.
        </p>

        <div className="mt-10 rounded-3xl border-2 border-slate-900 p-5" data-testid="review-qr">
          <QRCodeSVG value={SITE.reviewUrl} size={240} level="M" bgColor="#ffffff" fgColor="#101828" marginSize={0} />
        </div>
        <p className="mt-4 font-display text-sm font-bold uppercase tracking-widest text-slate-900">Scan to leave a review</p>

        <div className="mt-3 flex items-center gap-1" aria-label="Five star rating">
          {Array.from({ length: 5 }).map((_, i) => (
            <Star key={i} className="h-5 w-5 fill-amber-400 text-amber-400" />
          ))}
        </div>

        <a
          href={SITE.reviewUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="btn-red mt-8 print:hidden"
          data-testid="review-tap-btn"
        >
          Tap to review on Google
        </a>

        <p className="mt-10 text-xs text-slate-500">
          {SITE.name} · {SITE.phoneMainDisplay} · fusionglass.com.au
        </p>
      </section>
    </main>
  );
}
